export const getcontactUsData = (state) => {
	return state.contactUsList.data;
}
export const getcontactUsLinks = (state) => {
	return state.contactUsList.links;
}
export const getcontactUsMeta = (state) => {
	return state.contactUsList.meta;
}